import { render, staticRenderFns } from "./VersionsSidebar.vue?vue&type=template&id=027b6ee6&scoped=true"
import script from "./VersionsSidebar.vue?vue&type=script&lang=js"
export * from "./VersionsSidebar.vue?vue&type=script&lang=js"
import style0 from "./VersionsSidebar.vue?vue&type=style&index=0&id=027b6ee6&prod&lang=scss&scoped=true"
import style1 from "./VersionsSidebar.vue?vue&type=style&index=1&id=027b6ee6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b6ee6",
  null
  
)

export default component.exports